import { service } from '@/utils/request'

export default {
  getDict (payload) {
    return service.get('/sys/dict/list', {
      params: payload
    })
  }
}
